import type { OperationVariables } from '@apollo/react-common';
import { type MutationComponentOptions } from 'react-apollo';

import { useMutationInterop } from './useMutationInterop';

export function MutationInterop<TData = any, TVariables = OperationVariables>({
	children,
	mutation,
	...props
}: MutationComponentOptions<TData, TVariables>): JSX.Element | null {
	const mutationTuple = useMutationInterop(mutation, props);
	return children(...mutationTuple);
}
